import React from "react";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
                                                  
import {SwiperSlide} from "swiper/react";
                                            
                                               
import {resetPage, setCategory} from "../actions/filter";

                                        
                       
                
                 
                                  
 

const CategorySwiperSlide = (props                          ) => {
    const {category} = props;

    return <SwiperSlide className="swiper-slide" key={"_" + props.key}>
	<span className="pad cat cat-09" data-testid={"categoryTile"}>
		<span>
			<button onClick={() => props.setCategory(category)} aria-label={category.title} className="img toggle-shop"
                        style={{backgroundImage: `url('${category.imageUrl}')`}} data-testid={"openCategory"}
                />
			<span className="title">
				<span className="categoryName" data-testid={"categoryTitle"}>
					{category.title}
				</span>
				<span className={"categoryCount"} data-testid={"categoryCount"}>
					{category.count}
				</span>
			</span>
		</span>
	</span>
    </SwiperSlide>;
};

function mapStateToProps(state                  , ownProps                          ) {
    return {};
}

function mapDispatchToProps(dispatch, ownProps                          ) {
    return {
        setCategory: (category          ) => {
            dispatch(resetPage());
            dispatch(setCategory(category.key));
        }
    };
}

CategorySwiperSlide.displayName = "SwiperSlide";
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CategorySwiperSlide));
